export default __webpack_public_path__ + "static/media/nx-close.eec7aba6.svg";